import "./ChatboxPath.css";

const ChatboxPath = ({ block, selected, setSelectedObject }) => {
    
    const onClick = ()=>{
        setSelectedObject(block.object_id)
        window.followBlock(block.object_id);
    }
    return (
        <div className="chatbox_path_container">
            <div className={"chatbox_path_icon " + block?.type.name +"_icon"} onClick={onClick}></div>
            <span className={ "hover_label_path " + block?.type.name +"_label_path " + (selected ? "selected_object_in_path" : "no_selected_object_in_path")} onClick={onClick}>{block?.name}</span>
        </div>
    );



};

export default ChatboxPath; 